import React from "react";
import {Formik} from "formik";
import {validator} from "@reside/forms";
import {
  H3,
  RadioGroupField,
  Button,
  Modal,
  ModalContent,
  ModalFooterButtons,
} from "@reside/ui";
import {AdmissionStatusEnum} from "../../services/AdmissionsService";
import {CancellationReason} from "./types";
import {getWorkflowLabel} from "../start-workflow/workflowMapping";

type Values = Readonly<{
  reason: string;
}>;

type Props = Readonly<{
  cancellationReasons: ReadonlyArray<CancellationReason>;
  residentName: string;
  admissionCode: string;
  admissionStatus: AdmissionStatusEnum;
  isOpen: boolean;
  isLoading: boolean;
  onRequestClose: () => void;
  onCancel: (data: Values) => void;
  workflowType: string;
}>;

export const DeleteAdmissionModal = ({
  cancellationReasons,
  residentName,
  admissionCode,
  admissionStatus,
  workflowType,
  isOpen,
  isLoading,
  onRequestClose,
  onCancel,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={isLoading ? undefined : onRequestClose}
    title={`Delete ${getWorkflowLabel(workflowType)} for ${residentName}`}
  >
    {({closeModal}) => (
      <Formik<Values>
        initialValues={{
          reason: "",
        }}
        validate={values =>
          validator.validateAll(values, {
            reason: "required",
          })
        }
        onSubmit={onCancel}
      >
        {({submitForm}) => (
          <>
            <ModalContent>
              <H3 color="gray100">
                {getWorkflowLabel(workflowType)} ID: {admissionCode}
              </H3>
              <RadioGroupField
                disabled={isLoading}
                name="reason"
                label={`Please pick a reason to delete this ${getWorkflowLabel(
                  workflowType,
                )}:`}
                options={cancellationReasons
                  .filter(
                    cancellationReason =>
                      cancellationReason.forStatuses.length === 0 ||
                      cancellationReason.forStatuses.some(
                        status => status === admissionStatus,
                      ),
                  )
                  .map(({cancellationReason}) => ({
                    value: cancellationReason,
                    label: cancellationReason,
                  }))}
              />
            </ModalContent>
            <ModalFooterButtons>
              <Button
                outline
                color="primary"
                disabled={isLoading}
                onClick={closeModal}
                testId="closeDeleteAdmissionModalButton"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                color="danger"
                disabled={isLoading}
                onClick={submitForm}
                testId="deleteAdmissionButton"
              >
                {isLoading ? "Deleting..." : "Delete"}
              </Button>
            </ModalFooterButtons>
          </>
        )}
      </Formik>
    )}
  </Modal>
);
